import { Container } from "react-bootstrap";

import "./App.css";
import Routes from './components/_routes';
import { AuthProvider } from "./Context";

function App() {
  return (
    <AuthProvider>
      <Container fluid>
        <Routes />
      </Container>
    </AuthProvider>
  	
  );
}

export default App;
